import * as types from "./types";

export function fetchAppSettingsStart() {
  return {
    type: types.FETCH_APP_SETTINGS_START
  };
}

export function fetchAppSettingsSuccess(settings) {
  return {
    type: types.FETCH_APP_SETTINGS_SUCCESS,
    settings
  };
}

export function cacheBackupSettings(settings) {
  return {
    type: types.CACHE_BACKUP_SETTINGS,
    settings
  };
}

export function cleanCache(key) {
  return {
    type: types.CLEAN_CACHE,
    key
  };
}

export function showNotification(alertName, params) {
  return {
    type: types.SHOW_NOTIFICATION,
    alertName,
    params
  };
}
export function hideNotification(alertName) {
  return {
    type: types.HIDE_NOTIFICATION,
    alertName
  };
}

export function showNotificationWithTimeout(alertName, params) {
  return dispatch => {
    let timer = null;
    dispatch(showNotification(alertName, params));

    timer = setTimeout(() => {
      dispatch(hideNotification(alertName));
      clearTimeout(timer);
    }, 3000);
  };
}

export function fetchAllPlansStart() {
  return {
    type: types.FETCH_ALL_PLANS_START
  };
}

export function fetchAllPlansSuccess(data) {
  return {
    type: types.FETCH_ALL_PLANS_SUCCESS,
    data
  };
}

export function initiateNewSocketConnection() {
  return {
    type: types.INITIATE_NEW_SOCKET_CONNECTION
  };
}

export function showNotificationWithTimeoutOf5Seconds(alertName, params) {
  return dispatch => {
    let timer = null;
    dispatch(showNotification(alertName, params));

    timer = setTimeout(() => {
      dispatch(hideNotification(alertName));
      clearTimeout(timer);
    }, 5000);
  };
}
